import { useState, useCallback } from 'react';
import listen from 'app/home/general-components/Speech/listen';

export const AIChatStatus = {
    idle: 1,
    listening: 2,
    thinking: 3,
    errorNotAllowed: 4,
};

export const AIChatMessageType = {
    userPrompt: 1,
};

export default function useAIChat(sendEvent) {
    const [status, setStatus] = useState(AIChatStatus.idle);
    const [messages, setMessages] = useState([]);

    const startListening = useCallback((language) => {
        setStatus(AIChatStatus.listening);
        let config = {};
        if (language === 'fa') {
            config = { lang: "fa-IR" };
        }
        listen(config).then(
            transcript => {
                console.log('You said: ' + (transcript || 'nothing'));
                if (transcript) {
                    setStatus(AIChatStatus.thinking);
                    setMessages(l => [...l, {
                        type: AIChatMessageType.userPrompt,
                        text: transcript,
                    }]);
                    sendEvent('text_prompt', {
                        "language": language,
                        "prompt": [transcript]
                    });
                } else {
                    setStatus(AIChatStatus.idle);
                }
            },
            event => { // error
                console.error(event);
                if (event && (
                    (event.error === "service-not-allowed") ||
                    (event.error === "not-allowed")
                )) {
                    setStatus(AIChatStatus.errorNotAllowed);
                } else {
                    setStatus(AIChatStatus.idle);
                }
            }
        );
    }, [sendEvent]);

    return { status, messages, startListening };
}

// listen({ lang: "fa-IR" }).then(
//     transcript => {
//         console.log('You said: ' + (transcript || 'nothing'));
//     },
//     console.error
// );
